import { Typography } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";


const AddUpdateDialog = ({
    open,
    title,
    children,
    onClose,
    maxWidth = "md",
}) => {

    // Prevent closing on backdrop click
    const handleDialogClose = (event, reason) => {
        if (reason && reason === "backdropClick") return;
        if (onClose) onClose(event, reason);
    };

    return (
        <Dialog open={open} onClose={handleDialogClose} fullWidth maxWidth={maxWidth}>
            {title && (
                <DialogTitle
                    sx={{
                        m: 0,
                        p: 2,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "relative",
                        textTransform: "uppercase",
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{ fontSize: "20px", fontWeight: 600, textAlign: "center" }}
                    >
                        {title}
                    </Typography>

                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
            )}

            <DialogContent sx={{ p: 2 }}>{children}</DialogContent>
        </Dialog>
    );
};

export default AddUpdateDialog;
